import React, { useState } from "react";
import changeLogData from "./changeLog.json";

const ChangeLogPage = () => {
  const [logData, setLogData] = useState(changeLogData);

  const headingStyle = {
    fontFamily: `'Segoe UI', 'Helvetica Neue', sans-serif`,
    fontWeight: 700,
    fontSize: '2.75rem',
    color: '#007bff', // Bootstrap primary color
    marginBottom: '2rem',
    letterSpacing: '0.5px',
    textAlign: 'center',
  };

  return (
    <div className="container py-5">
      {/* <h1 className="mb-5 text-center fw-bold display-6 text-primary">What's New</h1> */}
      <h1 style={headingStyle}>What's New</h1>


      {[...changeLogData].reverse().map((entry, index) => (
        <div
          key={index}
          className="card shadow-sm mb-4 border-0 rounded-4"
          style={{ backgroundColor: "#f8f9fa" }} // light gray background
        >
          <div className="card-body">
            <div className="mb-3">
              <span className="badge bg-secondary fs-6">{entry.date}</span>
            </div>
            <ul className="list-unstyled mb-0">
              {entry.changes.map((change, idx) => (
                <li key={idx} className="mb-2 d-flex align-items-start">
                  <span className="me-2 text-success">✔</span>
                  <span>{change}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChangeLogPage;
